import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {registerLocaleData} from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import localeEnGb from "@angular/common/locales/en-GB";
import localeNl from "@angular/common/locales/nl";
import localeIt from "@angular/common/locales/it";
import localeEs from "@angular/common/locales/es";
import localeDe from "@angular/common/locales/de";
import '@progress/kendo-angular-intl/locales/fr/all';
import '@progress/kendo-angular-intl/locales/en-GB/all';
import '@progress/kendo-angular-intl/locales/nl/all';
import '@progress/kendo-angular-intl/locales/it/all';
import '@progress/kendo-angular-intl/locales/es/all';
import '@progress/kendo-angular-intl/locales/de/all';
import {ApplicationConfig, importProvidersFrom, inject, isDevMode, LOCALE_ID, provideAppInitializer} from "@angular/core";
import {provideRouter} from "@angular/router";
import {provideAnimations} from "@angular/platform-browser/animations";
import {OAuthModule} from "angular-oauth2-oidc";
import { provideTranslocoMessageformat } from "@jsverse/transloco-messageformat";
import { provideTransloco } from "@jsverse/transloco";
import { provideTranslocoLocale } from "@jsverse/transloco-locale";

registerLocaleData(localeFr);
registerLocaleData(localeEnGb);
registerLocaleData(localeNl);
registerLocaleData(localeIt);
registerLocaleData(localeEs);
registerLocaleData(localeDe);

import {AjouterAutorisation} from "../../../../val-authentification-lib/src/public-api";
import {ConvertirHttpDateInterceptor} from "../../../../val-ammon-composants/val-composants-lib/src/public-api";
import {routes} from "./app.routes";
import {ChargerConfiguration, ValAppSettingsService} from "../../../../val-ammon-services/val-app-settings-lib/src/public-api";
import { TranslocoHttpLoader, ValLangueService } from "../../../../val-definitions-communes-lib/src/public-api";
import {provideLangueUtilisateur} from "../../../../val-ammon-services/val-services-lib/src/public-api";

//Représente la configuration de l’application
export const appConfig: ApplicationConfig = 
{
  providers: 
  [
    provideHttpClient (withInterceptors ([AjouterAutorisation, ConvertirHttpDateInterceptor])),
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom (OAuthModule.forRoot ()),
    provideAppInitializer(() => 
    {
      const initializerFn = (ChargerConfiguration)(inject(ValAppSettingsService));
      return initializerFn();
    }),
    //Les montants sont en euros quelle que soit la langue : sans mapping, en-GB afficherait des livres
    provideTranslocoLocale({
      langToLocaleMapping: { fr: 'fr-FR', en: 'en-GB', nl: 'nl-NL', it: 'it-IT', es: 'es-ES', de: 'de-DE' },
      localeToCurrencyMapping: { 'fr-FR': 'EUR', 'en-GB': 'EUR', 'nl-NL': 'EUR', 'it-IT': 'EUR', 'es-ES': 'EUR', 'de-DE': 'EUR' },
      defaultCurrency: 'EUR'
    }),
    provideTransloco({
      config: {
        availableLangs: ['fr', 'en', 'nl', 'it', 'es', 'de'],
        defaultLang: 'fr',
        //Une clé absente d’une langue s’affiche en français plutôt qu’en clé brute
        fallbackLang: 'fr',
        missingHandler: { useFallbackTranslation: true },
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }),
    provideTranslocoMessageformat(),
    //La langue choisie suit l’utilisateur d’un poste à l’autre (préférences Ammon Services)
    provideLangueUtilisateur (),
    //Rétablit le choix mémorisé dès le démarrage, y compris sur un rechargement qui ne repasse pas par le callback
    provideAppInitializer(() => inject(ValLangueService).Initialiser()),
    { provide: LOCALE_ID, useValue: 'fr-FR' }
  ]
};
